import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import AddIcon from '@mui/icons-material/Add';
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import WhatsAppButton from "../components/WhatsAppButton";

const MotionAddIcon = motion(AddIcon);
// Componente de card isolado

const handleSendToMeta = (title) => {

    let text = `NichosClick${title.replace(" ", "")}`

    const isFbqAvailable = typeof window.fbq !== 'undefined';

    if (isFbqAvailable) {
        console.log(`Rastreando evento ${text} no Facebook Pixel`);
        window.fbq('trackCustom', text, {
            numberOfClicks: 1
        });
    }
}


const NicheCard = ({ title, description, link }) => {
    const [flipped, setFlipped] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div
            style={{
                perspective: "1000px",
                width: "200px",
                height: "200px",
            }}
            onClick={() => {
                handleSendToMeta(title)
                if (link) {
                    window.open(link, "_blank");
                } else {
                    setFlipped(!flipped);
                }
            }}
        >
            <motion.div
                style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    transformStyle: "preserve-3d",
                    borderRadius: "10px",
                }}
                animate={{ rotateY: flipped ? 180 : 0 }}
                transition={{ duration: 0.6 }}
            >
                {/* Frente */}
                <div
                    style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        backgroundColor: link ? "#9C01B9" : "#1EFF86",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                >
                    <p
                        style={{
                            color: link ? "white" : "black",
                            textAlign: "center",
                            fontWeight: "bold",
                            padding: "0 10px",
                        }}
                    >
                        {title}
                    </p>

                    <MotionAddIcon
                        sx={{ fontSize: "35px", color: "#0b243d" }}
                        animate={{
                            scale: flipped ? 1 : [1, 1.2, 1],
                            opacity: flipped ? 1 : [1, 0.7, 1],
                        }}
                        transition={{
                            duration: 1.2,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                    />
                </div>

                {/* Verso */}
                <div
                    style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                        backgroundColor: "#0b243d",
                        color: "white",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                        textAlign: "center",
                        fontSize: "14px",
                    }}
                >
                    {description}
                </div>
            </motion.div>
        </div>
    );
};

const Niches = () => {
    const listNiches = [
        {
            title: "Freelas",
            description: "Mais briefing, menos burocracia e você focado no seu talento.",
        },
        {
            title: "Creators",
            description: "Organize sua monetização e impostos com tranquilidade.",
        },
        {
            title: "Alt models",
            description: "Organize sua receita nacional e internacional sem burocracia.",
        },
        {
            title: "Infoprodutores",
            description: "Do mil ao milhão, sem problemas com o Leão.",
        },
        {
            title: "MEIs",
            description: "Contabilidade online sem surpresas nem atrasos para prestadores de serviços em geral.",
        },
        {
            title: "Anywhere office",
            description: "Pra quem já é 100% digital e trabalha de qualquer lugar do mundo.",
        },
        {
            title: "Digital influencers",
            description: "A gente entende de publis, monetização, contratos e emissão de notas fiscais.",
        },
        {
            title: "Gamers & Streamers",
            description: "Lives, donations, recebimentos da gringa e monetização organizados com segurança.",
        },
        {
            title: "Devs",
            description: "PJ, contratos internacionais, software houses e recebimentos do exterior sem complicação.",
        },
        {
            title: "Designers & Marketing",
            description: "Gestão financeira e tributária pra quem vive de criatividade, projetos e clientes digitais.",
        },
        {
            title: "Não encontrou sua categoria?",
            description: "Clique e fale conosco para saber como podemos ajudar sua profissão.",
            link: gerarLinkWhatsApp(
                "Olá! Não encontrei minha categoria na lista. Poderiam verificar se atendem minha profissão e me passar mais detalhes?"
            ),
        },
    ];

    return (
        <>
            <Header active="nichos" />

            {/* Seção de introdução */}
            <div style={{
                marginTop: "60px",
                width: "100%",
                padding: "20px",
                backgroundColor: "#233344",
                color: "white"
            }}>
                <div
                    style={{
                        width: "80%",
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "20px",
                    }}
                >
                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <img
                            src="/assets/sobreNos.jpg"
                            alt="Descrição"
                            style={{ width: "100%", height: "auto", borderRadius: "50%" }}
                        />
                    </motion.div>

                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>Nichos</h1>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                            Cada criador tem sua própria rotina e desafios. Por isso, oferecemos <b>atendimento contábil personalizado para influencers, gamers, alt models, streamers</b> e outros profissionais digitais.
                            Nossos serviços são pensados para se ajustar ao seu dia a dia, garantindo <b>organização financeira, segurança fiscal e liberdade</b> para focar no que você faz de melhor.
                        </p>
                    </motion.div>
                </div>
            </div>

            {/* Cards de nichos */}
            <div style={{ width: "100%", backgroundColor: "#f2f2f2", padding: "40px 0" }}>
                <div
                    style={{
                        width: "80%",
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "30px",
                    }}
                >
                    {listNiches.map((niche, index) => (
                        <NicheCard key={index} title={niche.title} description={niche.description} link={niche.link ? niche.link : ""} />
                    ))}
                </div>
            </div>

            <Footer />
            <WhatsAppButton />
        </>
    );
};

export default Niches;
